const countryLanguageCode = {
  CL: 'es-cl',
  PE: 'es-pe',
};

const languageCode = countryLanguageCode[process.env.COUNTRY].split('-');

export const pathLanguageCode = languageCode[0].concat('-', languageCode[1].toUpperCase());
